const environment = {
  production: false,
  environmentName: "dev",
  apiUrl: "https://dev-erm-datamigrator.wcgclinical.com/api/",
  ermUrl: "https://dev-ereviewmanager.wcgclinical.com",
  cnx5Url: "https://dev-connexus.wcgirb.com",
  okta: {
    issuer: "https://preview.wcgclinical.com/oauth2/default",
    baseUrl: "https://preview.wcgclinical.com",
    clientId: "0oaptynxox4HTyUoe1d7",
    redirectUri:
      "https://dev-erm-datamigrator.wcgclinical.com/auth/login/callback",
    postLogoutRedirectUri:
      "https://dev-erm-datamigrator.wcgclinical.com/auth/login",
    scopes: ["openid", "profile", "email", "offline_access"],
    disableHttpsCheck: true,
    useClassicEngine: true,
  },
  maxSessionLength: 24 * 60 * 60 * 1000, // 24 hours
  sessionTimeout: 58 * 60 * 1000, // 58 minutes
  sessionGracePeriod: 2 * 60 * 1000, // 2 minutes
};
export default environment;
